import React from "react";
import "../styles/components/advantage_card.css";

const AdvantageCard = ({ icon, title, description }) => {
  return (
    <div className="advantage-card">
      <div className="advantage-icon">{icon}</div>
      <h3 className="advantage-title">{title}</h3>
      <p className="advantage-description">{description}</p>
    </div>
  );
};

export default AdvantageCard;
